import { useContext } from 'react';
import { ShellAuth0Context, type ShellAuth0ContextInterface } from './context';

/**
 * Returns the current shell-aware Auth0 state. Behaves identically in
 * standalone and shell mode — the call site never needs to know which mode
 * the surrounding `ShellAuth0Provider` is running in.
 *
 * Throws if used outside a `ShellAuth0Provider` (a misconfiguration that
 * would otherwise surface as a confusing null-property access).
 */
export function useShellAuth0(): ShellAuth0ContextInterface {
  const ctx = useContext(ShellAuth0Context);
  if (ctx === null) {
    throw new Error('useShellAuth0 must be used within a ShellAuth0Provider');
  }
  return ctx;
}
